$ = require 'jquery'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
getExperiment = require 'lib/experiments/simple-test'
template = require 'views/templates/list_add'
track = require 'debug/track'

module.exports = class InlineListComposerView extends View
  className: 'js-add-list list-wrapper mod-add is-idle'

  initialize: ->
    @listenTo @model.viewState, 'change:listComposerOpen',
      @frameDebounce @renderListComposer

    @listenTo @model, 'change:limits', @render

    @listenTo @model.listList, 'add remove', @render

  events:
    'click .js-open-add-list': 'setOpen'
    'click .js-cancel-edit': 'setClose'
    'submit': 'addList'

  render: ->
    isFirstList = @model.listList.length == 0
    distinctLists = getExperiment('distinctLists').get('enabled')

    @$el.toggleClass('distinct-add-list', distinctLists)

    @$el.html(
      template({
        tooManyTotalLists: @model.isOverLimit('lists', 'totalPerBoard')
        tooManyOpenLists: @model.isOverLimit('lists', 'openPerBoard')
        isFirstList: isFirstList,
        distinctLists: distinctLists
      })
    )

    @renderListComposer()
    @renderListShadow()

    if distinctLists && isFirstList
      @setOpen()

    if @model.editable()
      @$el.removeClass('fade hide')

    @

  setOpen: (e) ->
    Util.stop(e)
    @model.viewState.set('listComposerOpen', true)
    return

  setClose: (e) ->
    Util.stop(e)
    @model.viewState.set('listComposerOpen', false)
    return

  renderListComposer: ->
    if @model.viewState.get('listComposerOpen') &&
    !@model.isOverLimit('lists', 'totalPerBoard') &&
    !@model.isOverLimit('lists', 'openPerBoard')
      @renderOpen()
    else
      @renderClose()

  renderOpen: (e) ->
    Util.stop(e)

    @$el.removeClass('is-idle')

    @defer =>
      @$('.list-name-input').blur().focus().select()

    PopOver.hide()
    return

  renderClose: (e) ->
    Util.stop(e)
    @$el.addClass('is-idle')
    return

  renderListShadow: ->
    distinctLists = getExperiment('distinctLists').get('enabled')

    @$el.toggleClass('list-shadow', distinctLists)

  addList: (e) ->
    Util.stop(e)

    $input = @$('.list-name-input')
    lists = @model.listList
    listsLength = lists.length + 1

    listName = $input.val().trim()

    if listName == ''
      $input.focus().select()
      return

    createdList = @model.listList.create(
      {
        name: listName,
        pos: @model.calcPos(listsLength),
        closed: false
      },
      {
        success: (model) =>
          track("Board View", "Add List - via Inline List Composer")
        error: =>
          @model.listList.remove(createdList)
      }
    )
    $input.val('')

    if getExperiment('distinctLists').get('enabled')
      @setClose()
      $('.js-open-card-composer').last().click()
    else
      @renderOpen()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/list/inline-list-composer-view.coffee